import { render, staticRenderFns } from "./MomentStyle1.vue?vue&type=template&id=417bc194"
import script from "./MomentStyle1.vue?vue&type=script&lang=js"
export * from "./MomentStyle1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports